angular.module('impactx.rfxsupplier').controller('RFXSupplierInfoHeaderCtrl', [
    RFXSupplierInfoHeaderController
]);

function RFXSupplierInfoHeaderController() {
    var self = this;

    self.$onInit = function () {
        self.panelExpanded = !self.isClosed;
    };

    self.togglePanelExpansion = function (event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        self.panelExpanded = !self.panelExpanded;
    };
}